function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodMealFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22.933 2.784c1.698-1.231 3.21-.791 3.378-.734A1 1 0 0127 3v27h-2V3.98c-.27.064-.604.201-.96.475-1.313 1.005-3.488 4.258-3.617 14.758h2.588v2h-3.595a1 1 0 01-1-1c0-9.392 1.52-15.255 4.517-17.429zM11.124 14.64c2.901-.48 5.123-2.998 5.123-6.033V2h-2v6.607a4.128 4.128 0 01-4.123 4.123A4.128 4.128 0 016 8.607V2H4v6.607c0 3.035 2.222 5.555 5.124 6.034V30h2V14.64z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.416 9.76a1 1 0 11-2 0V2h2v7.76zM12.832 9.76a1 1 0 11-2 0V2h2v7.76z",
    fill: props.color
  }));
}

export default SvgIconFoodMealFilled;